export default __webpack_public_path__ + "static/media/ic_info.79b28091.webp";